(()=>{
 // EasySell reads Shopify.locale when creating its card checkout and redirect.
 ['es_hook_before_checkout','es_hook_before_submit'].forEach(name=>{
  const previous=window[name];
  window[name]=function(...args){
   if(window.Shopify)window.Shopify.locale='tr';
   if(typeof previous==='function')return previous.apply(this,args);
  };
 });
 window.deFetch=async(input,options={})=>{
  const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),20000);
  try{return await fetch(input,{...options,signal:controller.signal})}
  catch(error){if(error.name==='AbortError')throw new Error('İstek gecikti. Tekrar denemeden önce sepetinizi kontrol edin.');throw error}
  finally{clearTimeout(timer)}
 };
 document.addEventListener('click',async event=>{
  const button=event.target.closest('[data-discount-apply]');if(!button)return;
  const section=button.closest('[data-de-cart]'),input=section.querySelector('[data-cart-discount]'),message=section.querySelector('[data-discount-message]'),code=input.value.trim();
  if(!code){message.textContent='Lütfen indirim kodunuzu yazın.';input.focus();return}
  button.disabled=true;message.textContent='Kod kontrol ediliyor…';
  try{
   const root=window.Shopify?.routes?.root||'/',response=await window.deFetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:code})});
   if(!response.ok||!/json|javascript/.test(response.headers.get('content-type')||''))throw Error('Kod şu anda kontrol edilemiyor. Lütfen tekrar deneyin.');
   const cart=await response.json(),applied=cart.discount_codes?.find(d=>d.code.toLowerCase()===code.toLowerCase()&&d.applicable);
   if(!applied){message.textContent='Bu kod sepetinizdeki ürünler için geçerli değil.';return}
   message.textContent='İndirim uygulandı. Sepetiniz güncelleniyor…';location.reload();
  }catch(error){message.textContent=error.message}
  finally{button.disabled=false}
 });
 document.addEventListener('keydown',event=>{if(event.target.matches('[data-cart-discount]')&&event.key==='Enter'){event.preventDefault();event.target.closest('[data-de-cart]').querySelector('[data-discount-apply]').click()}});
})();
